import TrackStatsPage from './TrackStatsPage';

export default TrackStatsPage;
